import NotificationService from '@/services/NotificationService';

class CadastroLoteNotificationHandler {
  static handleNotification(notification) {
    if (notification.type !== 'CADASTRO_LOTE') return;

    const notificationObj = {
        id: `cadastro_lote_${notification.metadata.arquivoId}`,
        type: 'CADASTRO_LOTE',
        status: notification.status,
        title: notification.title,
        message: notification.message,
        category: 'Cadastro em Lote',
        timestamp: notification.timestamp,
        metadata: notification.metadata,
        actions: []
    };

    if (notification.status === 'VALIDADO_COM_ERRO') {
        notificationObj.actions.push({
            label: 'Ver Planilhas',
            icon: 'el-icon-document',
            type: 'warning',
            handler: (vm) => {
                if (vm && vm.$router) {
                    vm.$router.push('/operacao/lote');
                }
            }
        });
    } else if (notification.status === 'PROCESSADO_COM_ERRO') {
        notificationObj.actions.push({
            label: 'Ver Detalhes',
            icon: 'el-icon-view',
            type: 'danger',
            handler: (vm) => {
                if (vm && vm.$router) {
                    vm.$router.push(`/operacao/lote/${notification.metadata.arquivoId}`);
                }
            }
        });
    } else if (notification.status === 'PROCESSADO') {
        notificationObj.actions.push({
            label: 'Ver Detalhes',
            icon: 'el-icon-view',
            type: 'primary',
            handler: (vm) => {
                if (vm && vm.$router) {
                    vm.$router.push(`/operacao/lote/${notification.metadata.arquivoId}`);
                }
            }
        });
    }

    NotificationService.addNotification(notificationObj);
  }

  static initializeListener() {
    window.addEventListener('generic-notification', (event) => {
        this.handleNotification(event.detail);
    });
  }
}

export default CadastroLoteNotificationHandler;
